<script>
export default {
  name: 'ErrorBox',
  props: {
    error: {
      required: true,
    },
  },
};
</script>

<template lang="pug">
  div.error-box.tc
    div.bg-black-overlay.relative._collision.pa5.lh-copy
      icon.w2.fill-green.mb3(name="warning")
      template(v-if="error === 'no-safety-state'")
        p.f6.white {{ $t('This station is in safety mode.') }}
        p.f6.white {{ $t('Please make sure to restore it from the monitor.') }}
      template(v-else-if="error === 'network'")
        p.f6.white {{ $t('There is no internet connection.') }}
        p.f6.white {{ $t('Please make sure you are connected and retry.') }}
      template(v-else-if="error === 'backend'")
        p.f6.white {{ $t('We are having trouble loading data.') }}
        p.f6.white {{ $t('Please retry or contact support if it is persisting.') }}
      template(v-else-if="error === 'disabled-organization'")
        p.f6.white {{ $t('Your organization is disabled.') }}
        p.f6.white {{ $t('Please go to the operator panel if you want to re-enable your account.') }}
      template(v-else)
        p.f6.white {{ $t('Unexpected error') }}
        p.f6.white {{ $t('Please retry or contact support if it is persisting.') }}
      link-style
        button.f6.dib.mt2.tc(type="button" @click="$emit('retry')") Reload
</template>

<style scoped>
.error-box {
}
</style>
